import "./App.css";
import Layout from "./components/Layout/Layout";
import { Route, Switch } from "react-router-dom";
import AboutPage from "./components/AboutPage/AboutPage";
import React, { Suspense } from "react";
import Spinner from "./components/UI/Spinner/Spinner";
import QuizPage from "./components/QuizPage/QuizPage";
import Page404 from "./components/Page404/Page404";

const AsyncTestPage = React.lazy(() =>
  import("./components/TestPage/TestPage")
);

const AsyncDevelopersPage = React.lazy(() =>
  import("./components/DevelopersPage/DevelopersPage")
);

function App() {
  return (
    <div className="App">
      <Layout>
        <Suspense fallback={<Spinner />}>
          <Switch>
            <Route exact path="/" component={QuizPage} />
            <Route path="/test" component={AsyncTestPage} />
            <Route path="/about" component={AboutPage} />
            <Route path="/developers" component={AsyncDevelopersPage} />
            <Route component={Page404} />
          </Switch>
        </Suspense>
      </Layout>
    </div>
  );
}

export default App;
